module.exports = __webpack_public_path__ + "img/calendar-check.56ad0994.svg";